import { moduleIndustries } from '../data/moduleIndustries'
import { moduleById } from '../data/skillModules'
import { Industry } from '../types/pathway'

export interface PathwayLibraryFilters {
  query: string
  industry: Industry | 'all'
  role: string
  topic: string
}

export function pathwayIndustries(moduleIds: string[]): Industry[] {
  return Array.from(
    new Set(moduleIds.flatMap((id) => moduleIndustries[id] ?? [])),
  )
}

export function pathwayTopics(moduleIds: string[]): string[] {
  return Array.from(
    new Set(moduleIds.flatMap((id) => moduleById(id)?.keywords ?? [])),
  ).sort((a, b) => a.localeCompare(b))
}

export function pathwayTopicOptions(moduleIdGroups: string[][]): string[] {
  return Array.from(new Set(moduleIdGroups.flatMap(pathwayTopics))).sort((a, b) =>
    a.localeCompare(b),
  )
}

export function matchesPathwayLibraryFilters(
  moduleIds: string[],
  audience: string,
  searchText: string,
  filters: PathwayLibraryFilters,
): boolean {
  const needle = filters.query.trim().toLowerCase()
  if (needle && !searchText.toLowerCase().includes(needle)) return false
  if (
    filters.industry !== 'all' &&
    !pathwayIndustries(moduleIds).includes(filters.industry)
  ) {
    return false
  }
  if (filters.role !== 'all' && audience !== filters.role) return false
  if (filters.topic !== 'all' && !pathwayTopics(moduleIds).includes(filters.topic)) {
    return false
  }
  return true
}
